import "./assets/Styles/App.css";
import { Portfolio } from "./Components/Portfolio/Portfolio";
import About from "./Components/About/About";
import Landing from "./Components/Landing/Landing";
import Contact from "./Components/Contact/Contact";
import Navbar from "./Components/Navbar/Navbar";

function App() {
  return (
    <div>
      <Navbar />
      <Landing />
      <About />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default App;

